import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { css } from 'styled-components'
import { withNamespaces } from 'react-i18next'

import Button from '../Forms/Button'
import Feedback from './Feedback'
import Disagreement from './Disagreement'
import Reopen from './Reopen'
import ChangeSeverityModal from './ChangeSeverityModal'

const Wrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  margin: 15px 18px 0 18px;

  padding-bottom: 15px;

  border-bottom: 1px solid #eeeff1;
`

const ContainerWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap-reverse;

  ${(props) =>
    props.closed &&
    css`
      @media (min-width: 992px) {
        justify-content: flex-end;
      }

      @media (min-width: 768px) {
        flex-wrap: nowrap;
      }
    `}
`

const StyledSeverity = styled.div`
  display: flex;
  flex-direction: row;
  /* flex: 0; */
  flex-wrap: nowrap;

  margin-top: 5px;
  margin-bottom: 10px;
  margin-right: 10px;

  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #8b93a7;
`

const SeverityChangeButton = styled.div`
  margin-left: 5px;
  color: #4c84ff;

  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`

const ButtonsBar = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;

  a,
  button {
    margin-right: 5px;
    margin-left: 5px;
  }

  button:last-child {
    margin-left: 0;
  }
  ${(props) =>
    !props.closed &&
    css`
      @media (max-width: 992px) {
        flex: 1 0 100%;
      }
    `}
`

const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const ControlButtons = styled.div`
  display: flex;
  flex: 1;
  /* justify-content: flex-end; */
  flex-direction: row-reverse;
`

class TopBar extends Component {
  state = {
    feedbackModal: false,
    disagreementModal: false,
    reopenModal: false,
    changeSeverityModal: false
  }

  render() {
    const {
      severity,
      showBackButton,
      feedback,
      state,
      closeTicket,
      sendFeedback,
      sendDisagreement,
      reopenTicket,
      forceDisableCloseButton,
      t
    } = this.props

    const isTicketClosed = state === 'Closed'
    const withMaxSize = document.documentElement.clientWidth > 768

    return (
      <Wrapper>
        <ContainerWrapper closed={isTicketClosed}>
          <Feedback
            toggle={this.toggleModal('feedbackModal')}
            isOpen={this.state.feedbackModal}
            closeTicket={closeTicket}
            sendFeedback={sendFeedback}
            isTicketClosed={isTicketClosed}
          />
          <Disagreement
            toggle={this.toggleModal('disagreementModal')}
            isOpen={this.state.disagreementModal}
            sendDisagreement={sendDisagreement}
            isTicketClosed={isTicketClosed}
          />
          <Reopen
            toggle={this.toggleModal('reopenModal')}
            isOpen={this.state.reopenModal}
            reopenTicket={reopenTicket}
            isTicketClosed={isTicketClosed}
          />
          <ChangeSeverityModal
            toggle={this.toggleModal('changeSeverityModal')}
            isOpen={this.state.changeSeverityModal}
            changeSeverityHandler={this.changeSeverityHandler}
            severity={severity}
          />

          {state !== 'Closed' && (
            <StyledSeverity>
              <React.Fragment>
                <span>
                  {t('severity:name')} {t(`severity:${severity}`)}
                </span>{' '}
                <SeverityChangeButton
                  onClick={this.toggleModal('changeSeverityModal')}
                >
                  {t('common:change')}
                </SeverityChangeButton>
              </React.Fragment>
            </StyledSeverity>
          )}

          <ButtonsBar closed={isTicketClosed}>
            {showBackButton && (
              <BackButtonWrapper>
                <Link to="/dashboard/interactions">
                  <Button outline>
                    <FontAwesomeIcon color="#fff" icon="arrow-left" />
                  </Button>
                </Link>
              </BackButtonWrapper>
            )}
            <ControlButtons>
              {isTicketClosed && (
                <Button
                  onClick={this.toggleModal('disagreementModal')}
                  bgColor="#DA692E"
                  maxSize={withMaxSize}
                >
                  {t('tickets:disagree')}
                </Button>
              )}
              {isTicketClosed && (
                <Button
                  onClick={this.toggleModal('reopenModal')}
                  bgColor="#4C84FF"
                  maxSize={withMaxSize}
                >
                  {t('tickets:reopen')}
                </Button>
              )}
              {isTicketClosed && feedback && (
                <Button
                  onClick={this.toggleModal('feedbackModal')}
                  bgColor="#4C84FF"
                  maxSize={withMaxSize}
                >
                  {t('tickets:leaveFeedback')}
                </Button>
              )}

              {state !== 'Closed' && (
                <React.Fragment>
                  <Button
                    onClick={this.toggleModal('disagreementModal')}
                    bgColor="#DA692E"
                    maxSize={withMaxSize}
                  >
                    {t('tickets:escalate')}
                  </Button>
                  <Button
                    onClick={this.toggleModal('feedbackModal')}
                    bgColor="#4C84FF"
                    maxSize={withMaxSize}
                    disabled={forceDisableCloseButton}
                  >
                    {t('tickets:close')}
                  </Button>
                </React.Fragment>
              )}
            </ControlButtons>
          </ButtonsBar>
        </ContainerWrapper>
      </Wrapper>
    )
  }

  changeSeverityHandler = (data) => {
    this.props.changeSeverity(data)
  }

  toggleModal = (name) => () => {
    this.setState({
      [name]: !this.state[name]
    })
  }
}

export default withNamespaces()(TopBar)
